const key = 'pk.eyJ1IjoiYW51anNoYXJtYTYyNyIsImEiOiJjazl1c3RwbnMwNHV3M25ydXFta3hiNWRhIn0.0g2cgeKluyOFnh0jm7tGRg'; export default {key: key};
